import type { ModuleNavigation } from '../../layouts/ModuleSidebar';

export const delegationNavigation: ModuleNavigation = [
  {
    title: 'Delegation',
    items: [
      { path: '/delegation/settings', label: 'Settings' },
      { path: '/delegation/set-deputy', label: 'Set My Deputy' },
      { path: '/delegation/authorise-standing', label: 'Authorise Standing' },
    ],
  },
];
